export default {
  name: 'rate',
  label: '星级评分',
  dataType: 'Number',
  icon: 'el-icon-star-off',
  config: [{
    // 可修改的配置选项
    xtype: 'number',
    options: {
      label: '最大分值',
      name: 'max',
      default: 5
    }
  }, {
    // 可修改的配置选项
    xtype: 'switcher',
    options: {
      label: '是否允许半选',
      name: 'allow-half',
      default: false
    }
  }]
};